import { useContext, useEffect, useRef } from "react";
import olMap from "ol/Map";
import { Coordinate } from "ol/coordinate";
import MapContext from "../map/MapContext";

export interface ViewCenterChangeProps {
  onCenterChange: (center: Coordinate) => void;
}

const ViewCenterChange = ({ onCenterChange }: ViewCenterChangeProps) => {
  const map = useContext(MapContext) as olMap;

  const onCenterChangeRef = useRef(onCenterChange);
  useEffect(() => {
    onCenterChangeRef.current = onCenterChange;
  }, [onCenterChange]);

  useEffect(() => {
    if (!map) return;
    const view = map.getView();

    const handler = () => {
      const center = view.getCenter();
      if (center) onCenterChangeRef.current(center);
    };

    view.on("change:center", handler);
    return () => {
      view.un("change:center", handler);
    };
  }, [map]);

  return null;
};

export default ViewCenterChange;
